<template>
  <div class="lots" v-if="client">
    <div class="top">
      <div class="leftside">
        <div
          class="image"
          :style="{backgroundImage: 'url('+require('@/assets/img/testimg.jpeg')+')'}"
        ></div>
      </div>
      <div class="side">
        <h2>Available Lots</h2>
        <p>Home Listings</p>

        <div class="navs">
          <div
            class="nav"
            :style="{backgroundColor: client.color.primary ? '#'+client.color.primary  : '#F26638'}"
            @click="goTo('/homes')"
          >
            <p>Contact</p>
            <img src="@/assets/img/next.svg" />
          </div>
          <div
            class="nav"
            :style="{backgroundColor: client.color.primary ? '#'+client.color.primary  : '#F26638'}"
            @click="goTo('/newhomes')"
          >
            <p>New Homes</p>
            <img src="@/assets/img/next.svg" />
          </div>
          <div
            class="nav"
            :style="{backgroundColor: client.color.primary ? '#'+client.color.primary  : '#F26638'}"
            @click="goTo('/homes')"
          >
            <p>Available Homes</p>
            <img src="@/assets/img/next.svg" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { db, functions, analytics } from "@/config/firebaseInit";
import Slider from "@/components/Slider";

export default {
  name: "homelots",
  components: {
    Slider
  },
  data() {
    return {
      client: this.$store.state.client,
      user: this.$store.state.user,
      show_images: true
    };
  },
  mounted() {},
  async created() {},
  watch: {},
  methods: {
    showImages(index) {
      this.show_images = true;
      setTimeout(() => {
        this.$refs.slider.current_index = index;
      }, 100);
    }
  }
};
</script>

<style lang="scss">
.lots {
  height: 100vh;
  width: 100vw;
  display: flex;
  flex-direction: column;
  .top {
    display: flex;
  }
  .side {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: 600px;
    padding: 100px 50px;
    padding-right: 150px;
    flex: none;
    padding-bottom: 0;
    .logo {
      width: 275px;
      margin: auto;
      margin-top: 50px;
      margin-bottom: 30px;
    }
    h2 {
      color: black;
      font-size: 55px;
      margin-bottom: 0;
    }
    p {
      font-size: 23px;
    }
  }
  .leftside {
    display: flex;
    flex-direction: column;
    width: 100%;
    padding-left: 100px;
    padding-top: 100px;
    .image {
      background-size: cover;
      background-repeat: no-repeat;
      height: 850px;
      width: 1200px;
    }
  }
  .bottom-choices {
    width: 100%;
    padding: 50px 100px;
    display: flex;
    justify-content: space-between;
    & > div {
      width: 31.5%;
      height: 330px;
      background-size: cover;
      background-repeat: no-repeat;
      position: relative;
      .dark {
        position: absolute;
        bottom: 0;
        left: 0;
        display: flex;
        padding: 50px;
        width: 100%;
        background: linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.8));
        p {
          color: white;
          font-weight: bold;
          font-size: 40px;
          text-transform: uppercase;
          margin-bottom: 0;
        }
        img {
          filter: brightness(0) invert(1);
          height: 30px;
          position: absolute;
          right: 50px;
          bottom: 60px;
        }
      }
    }
  }
}
</style>
